import React, { useState, useRef, useEffect } from "react";
import { Html5Qrcode } from "html5-qrcode";
import {
  Card,
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
} from "react-bootstrap";
import { MdInsertChartOutlined } from "react-icons/md";
import { BiScan } from "react-icons/bi";
import Swal from "sweetalert2";
import { venueManagerBookingUrl } from "../services/adminApiService/venueManagerApi/venueManagerApi";
import "./styles.css";

function Dashboard() {
 
  const [bookingId, setBookingId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const isScanHandled = useRef(false);
  const qrScannerRef = useRef(null);

  const startScanner = () => setShowScanner(true);

  const stopScanner = () => {
    if (isScanning && qrScannerRef.current) {
      qrScannerRef.current
        .stop()
        .then(() => {
          qrScannerRef.current.clear();
          setShowScanner(false);
          setIsScanning(false);
        })
        .catch((err) => {
          console.warn("Error stopping scanner:", err);
        });
    } else {
      setShowScanner(false);
    }
  };

  useEffect(() => {
    if (showScanner) {
      const html5QrCode = new Html5Qrcode("qr-reader");
      qrScannerRef.current = html5QrCode;
      isScanHandled.current = false;

      html5QrCode
        .start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 250, height: 250 } },
          async (decodedText) => {
            if (isScanHandled.current) return;
            isScanHandled.current = true;
            console.log(decodedText,"decodedText")

            try {
              let bookingId;

              if (
                decodedText.trim().startsWith("{") &&
                decodedText.trim().endsWith("}")
              ) {
                try {
                  const parsed = JSON.parse(decodedText);
                  bookingId = parsed.booking_id;
                  if (!bookingId) throw new Error("Missing booking_id in QR");
                } catch (err) {
                  console.error("Invalid QR JSON format:", err);
                  Swal.fire("Invalid QR code format. Please try again.");
                  stopScanner();
                  return;
                }
              } else {
                const lastSegment = decodedText.substring(
                  decodedText.lastIndexOf("/") + 1
                );
                bookingId = lastSegment.split("_")[0];
              }

              await handleCheck(bookingId);
              stopScanner();
            } catch (err) {
              console.error("QR scan handling error:", err);
              Swal.fire("Error processing QR code.");
              stopScanner();
            }
          },
          (error) => {
            // Optional: console.log("Scan error:", error);
          }
        )
        .then(() => setIsScanning(true))
        .catch((err) => {
          console.error("QR Scanner start error:", err);
          Swal.fire("Unable to start QR scanner. Please check camera access.");
        });
    }

    return () => {
      const stopAndClearScanner = async () => {
        if (qrScannerRef.current) {
          try {
            if (isScanning) {
              await qrScannerRef.current.stop();
            }
            await qrScannerRef.current.clear();
          } catch (err) {
            console.error("Error stopping or clearing QR scanner:", err);
          }
        }
      };
      stopAndClearScanner();
    };
  }, [showScanner]);

  const handleCheck = async (bookingId) => {
    setLoading(true);
    try {
  
      const response = await venueManagerBookingUrl(bookingId);

      if (response.data.success) {
        localStorage.setItem(
          "venueManagerBookingId",
          response?.data?.data?.id
        );

        window.location.href = `/booking-details/${response?.data?.data?.id}`;
        
        // Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: response.data.message,
        //   confirmButtonText: "Go to Booking Details",
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     window.location.href = `/booking-details/${response?.data?.data?.id}`;
        //   }
        // });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.data?.message || "Something went wrong.",
          showCloseButton: true,
        });
      }
    } catch (error) {
      console.error("Booking check error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
        showCloseButton: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div className="text-center my-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <Container className="my-0">
          <div className="mx-3 pb-3 fs-3">Dashboard</div>

          <Card className="text-white text-center user-booking-stats">
            <Card.Body>
              <h4 className="mb-0 text-white">
                <MdInsertChartOutlined className="fs-1" /> User Bookings
              </h4>
            </Card.Body>
          </Card>

          <Row className="mt-4">
            <Col md={6} className="mb-3">
              <Card
                className="text-center p-4"
                onClick={startScanner}
                style={{
                  backgroundColor: "#f4ebfa",
                  border: "1px solid #ccc",
                  borderRadius: "0.75rem",
                  cursor: "pointer",
                }}
              >
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ fontSize: "2rem", color: "#6f42c1" }}
                >
                  <div className="scanner">
                    <BiScan className="fs-3" />
                  </div>
                </div>
                <h5 className="mt-2 fw-bold fs-4">Scan QR Code</h5>
                <p className="text-muted mb-0 fs-4">
                  Allow users to enter venue by scanning their QR code.
                </p>
              </Card>
            </Col>

            {/* QR Scanner Modal */}
            <Modal show={showScanner} onHide={stopScanner} centered>
              <Modal.Header closeButton>
                <Modal.Title>Scan QR Code</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div id="qr-reader" style={{ width: "100%" }} />
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={stopScanner}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>

            <Col md={6} className="mb-3">
              <Card
                className="p-4 text-center"
                style={{
                  backgroundColor: "#f4ebfa",
                  border: "1px solid #ccc",
                  borderRadius: "0.75rem",
                }}
              >
                <h5 className="fw-bold mb-3 fs-4">Booking ID Number</h5>
                <Form.Control
                  type="text"
                  placeholder="Enter booking id"
                  className="mb-3"
                  value={bookingId}
                  onChange={(e) => setBookingId(e.target.value)}
                  style={{ textAlign: "center" }}
                />
                <div className="text-center">
                  <Button
                    className="fs-5"
                    style={{
                      background: "linear-gradient(to right,rgb(81, 192, 124),rgb(7, 146, 42))",
                      border: "none",
                      width: "150px",
                    }}
                    onClick={() => handleCheck(bookingId)}
                  >
                    Verify
                  </Button>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default Dashboard;